import * as i0 from '@angular/core';
import { Component, Input, Injectable, Directive, HostListener, NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { EquisPositionsType, debounceDecorator } from '@tn-equis/core/utils';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@tn-equis/core/services';
import { EquisComponentInsertionService, EquisNavigatorService, EquisWindowService } from '@tn-equis/core/services';
import { __decorate } from 'tslib';
import { fromEvent } from 'rxjs';

class EquisTooltipComponent {
    constructor() {
        this.content = '';
        this.direction = EquisPositionsType.TOP;
        this.icon = '';
    }
    get getPosition() {
        return `tooltip--${this.direction}`;
    }
}
EquisTooltipComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisTooltipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisTooltipComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisTooltipComponent, selector: "z-tooltip , equis-tooltip", inputs: { content: "content", direction: "direction", icon: "icon", fixedWidth: "fixedWidth" }, ngImport: i0, template: "<div\n  class=\"equis-body-2 tooltip d-flex\"\n  [ngClass]=\"[getPosition]\"\n  [ngStyle]=\"{ 'max-width': fixedWidth }\"\n>\n  <div class=\"icon tooltip__icon\" *ngIf=\"icon\">\n    <p [ngClass]=\"icon\" class=\"size-16\"></p>\n  </div>\n  <p class=\"equis-body-2 tooltip__text\">\n    {{ content }}\n  </p>\n</div>\n", styles: [".tooltip{align-items:flex-start;background-color:#333;border-radius:8px;box-sizing:border-box;display:flex;flex-direction:row;justify-content:left;margin:0;max-width:160px;padding:12px;position:relative;width:-moz-max-content;width:max-content}.tooltip__icon{color:#fff;margin-right:8px}.tooltip:after{background-color:#333;border-radius:2px;content:\"\";height:12px;position:absolute;transform:translate(-50%,-50%) rotate(45deg);width:12px}.tooltip--bottom:after{left:50%;left:var(--after-left, 50%);top:1px;top:calc(var(--after-top, 0px) + 1px)}.tooltip--left:after{left:calc(100% - 1px);left:calc(var(--after-left, 100%) - 1px);top:50%;top:var(--after-top, 50%)}.tooltip--top:after{left:50%;left:var(--after-left, 50%);top:calc(100% - 1px);top:calc(var(--after-top, 100%) - 1px)}.tooltip--right:after{left:1px;left:calc(var(--after-left, 0px) + 1px);top:50%;top:var(--after-top, 50%)}.tooltip--top-left:after{left:24px;left:var(--top-left, 24px);top:calc(100% - 1px);top:calc(var(--after-top, 100%) - 1px)}.tooltip--top-left-icon:after{left:50px;left:var(--top-left, 50px);top:calc(100% - 1px);top:calc(var(--after-top, 100%) - 1px)}.tooltip--top-right:after{right:14px;right:var(--after-left, 14px);top:calc(100% - 1px);top:calc(var(--after-top, 100%) - 1px)}.tooltip--bottom-left:after{left:50px;left:var(--after-left, 50px);top:1px;top:calc(var(--after-top, 0px) + 1px)}.tooltip--bottom-right:after{right:14px;right:var(--after-left, 14px);top:1px;top:calc(var(--after-top, 0px) + 1px)}.tooltip--left-bottom:after{bottom:4px;bottom:var(--after-top, 4px);left:calc(100% - 1px);left:calc(var(--after-left, 100%) - 1px)}.tooltip--left-top:after{left:calc(100% - 1px);left:calc(var(--after-left, 100%) - 1px);top:16px;top:var(--after-top, 16px)}.tooltip--right-top:after{left:1px;left:calc(var(--after-left, 0px) + 1px);top:16px;top:var(--after-top, 16px)}.tooltip--right-bottom:after{bottom:4px;bottom:var(--after-top, 4px);left:1px;left:calc(var(--after-left, 0px) + 1px)}.tooltip__text{color:#fff}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisTooltipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-tooltip , equis-tooltip', template: "<div\n  class=\"equis-body-2 tooltip d-flex\"\n  [ngClass]=\"[getPosition]\"\n  [ngStyle]=\"{ 'max-width': fixedWidth }\"\n>\n  <div class=\"icon tooltip__icon\" *ngIf=\"icon\">\n    <p [ngClass]=\"icon\" class=\"size-16\"></p>\n  </div>\n  <p class=\"equis-body-2 tooltip__text\">\n    {{ content }}\n  </p>\n</div>\n", styles: [".tooltip{align-items:flex-start;background-color:#333;border-radius:8px;box-sizing:border-box;display:flex;flex-direction:row;justify-content:left;margin:0;max-width:160px;padding:12px;position:relative;width:-moz-max-content;width:max-content}.tooltip__icon{color:#fff;margin-right:8px}.tooltip:after{background-color:#333;border-radius:2px;content:\"\";height:12px;position:absolute;transform:translate(-50%,-50%) rotate(45deg);width:12px}.tooltip--bottom:after{left:50%;left:var(--after-left, 50%);top:1px;top:calc(var(--after-top, 0px) + 1px)}.tooltip--left:after{left:calc(100% - 1px);left:calc(var(--after-left, 100%) - 1px);top:50%;top:var(--after-top, 50%)}.tooltip--top:after{left:50%;left:var(--after-left, 50%);top:calc(100% - 1px);top:calc(var(--after-top, 100%) - 1px)}.tooltip--right:after{left:1px;left:calc(var(--after-left, 0px) + 1px);top:50%;top:var(--after-top, 50%)}.tooltip--top-left:after{left:24px;left:var(--top-left, 24px);top:calc(100% - 1px);top:calc(var(--after-top, 100%) - 1px)}.tooltip--top-left-icon:after{left:50px;left:var(--top-left, 50px);top:calc(100% - 1px);top:calc(var(--after-top, 100%) - 1px)}.tooltip--top-right:after{right:14px;right:var(--after-left, 14px);top:calc(100% - 1px);top:calc(var(--after-top, 100%) - 1px)}.tooltip--bottom-left:after{left:50px;left:var(--after-left, 50px);top:1px;top:calc(var(--after-top, 0px) + 1px)}.tooltip--bottom-right:after{right:14px;right:var(--after-left, 14px);top:1px;top:calc(var(--after-top, 0px) + 1px)}.tooltip--left-bottom:after{bottom:4px;bottom:var(--after-top, 4px);left:calc(100% - 1px);left:calc(var(--after-left, 100%) - 1px)}.tooltip--left-top:after{left:calc(100% - 1px);left:calc(var(--after-left, 100%) - 1px);top:16px;top:var(--after-top, 16px)}.tooltip--right-top:after{left:1px;left:calc(var(--after-left, 0px) + 1px);top:16px;top:var(--after-top, 16px)}.tooltip--right-bottom:after{bottom:4px;bottom:var(--after-top, 4px);left:1px;left:calc(var(--after-left, 0px) + 1px)}.tooltip__text{color:#fff}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { content: [{
                type: Input
            }], direction: [{
                type: Input
            }], icon: [{
                type: Input
            }], fixedWidth: [{
                type: Input
            }] } });

class EquisTooltipPositionService {
    //Este servicio retorna z-index value se utiliza para acomodar elementos en el eje Z (profundidad)
    getIndex(index) {
        return { style: 'z-index', value: `${index}` };
    }
    getPosition(host, componentInstance, direction, margin) {
        let redirection = direction;
        const componentPos = componentInstance.location.nativeElement.children[0].getBoundingClientRect();
        const hostPos = host.getBoundingClientRect();
        let bounds = this.checkBoundaries(direction, hostPos, componentPos, margin);
        if (!bounds.valid) {
            const positionsList = [
                EquisPositionsType.TOP,
                EquisPositionsType.RIGHT,
                EquisPositionsType.LEFT,
                EquisPositionsType.BOTTOM,
            ];
            redirection = positionsList.find((pos) => this.checkBoundaries(pos, hostPos, componentPos, margin).valid);
            bounds = this.checkBoundaries(redirection, hostPos, componentPos, margin);
        }
        const afterTop = bounds.afterTop;
        const afterLeft = bounds.afterLeft;
        const left = bounds.left;
        const top = bounds.top;
        return { left, top, redirection, afterTop, afterLeft };
    }
    checkBoundaries(direction, hostPos, componentPos, margin) {
        const position = this.calculatePosition(direction, hostPos, componentPos, margin);
        let valid = true;
        let left = position.left;
        let top = position.top;
        let afterTop;
        let afterLeft;
        // Checks if host has offset left or right
        const hostOffsetX = hostPos.x < 0 || window.innerWidth < hostPos.x + hostPos.width;
        // Checks if host has offset top or bottom
        const hostOffsetY = hostPos.y < 0 || window.innerHeight < hostPos.y + hostPos.height;
        // Calc tooltip's left or right offset
        const offsetLeft = hostPos.x - (componentPos.width - hostPos.width) / 2;
        const offsetRight = hostPos.x +
            componentPos.width / 2 +
            hostPos.width / 2 -
            window.innerWidth;
        // Calc tooltip's top or bottom offset
        const offsetTop = hostPos.y - (componentPos.height - hostPos.height) / 2;
        const offsetBottom = hostPos.y +
            componentPos.height / 2 +
            hostPos.height / 2 -
            window.innerHeight;
        switch (direction) {
            case EquisPositionsType.BOTTOM:
                if (window.innerHeight -
                    (hostPos.y + hostPos.height + componentPos.height) <
                    0 ||
                    hostOffsetX) {
                    valid = false;
                }
                else if (0 < offsetRight) {
                    left = left - offsetRight;
                    afterLeft = (offsetRight * 100) / componentPos.width;
                }
                else if (offsetLeft < 0) {
                    left = left - offsetLeft;
                    afterLeft = (offsetLeft * 100) / componentPos.width;
                }
                break;
            case EquisPositionsType.LEFT:
                if (hostPos.x - componentPos.width < 0 || hostOffsetY) {
                    valid = false;
                }
                else if (0 < offsetBottom) {
                    top = top - offsetBottom;
                    afterTop = (offsetBottom * 100) / componentPos.height;
                }
                else if (offsetTop < 0) {
                    top = top - offsetTop;
                    afterTop = (offsetTop * 100) / componentPos.height;
                }
                break;
            case EquisPositionsType.RIGHT:
                if (window.innerWidth - (hostPos.x + hostPos.width + componentPos.width) <
                    0 ||
                    hostOffsetY) {
                    valid = false;
                }
                else if (0 < offsetBottom) {
                    top = top - offsetBottom;
                    afterTop = (offsetBottom * 100) / componentPos.height;
                }
                else if (offsetTop < 0) {
                    top = top - offsetTop;
                    afterTop = (offsetTop * 100) / componentPos.height;
                }
                break;
            default:
                if (hostPos.y - componentPos.height < 0 || hostOffsetX) {
                    valid = false;
                }
                else if (0 < offsetRight) {
                    left = left - offsetRight;
                    afterLeft = (offsetRight * 100) / componentPos.width;
                }
                else if (offsetLeft < 0) {
                    left = left - offsetLeft;
                    afterLeft = (offsetLeft * 100) / componentPos.width;
                }
                break;
        }
        return { valid, left, top, afterTop, afterLeft };
    }
    calculatePosition(direction, hostPos, componentPos, margin) {
        const scrollPosY = window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;
        const scrollPosX = window.pageXOffset ||
            document.documentElement.scrollLeft ||
            document.body.scrollLeft ||
            0;
        let top;
        let left;
        switch (direction) {
            case EquisPositionsType.BOTTOM:
                top = hostPos.bottom + margin;
                left = hostPos.left + (hostPos.width - componentPos.width) / 2;
                break;
            case EquisPositionsType.LEFT:
                top = hostPos.top + (hostPos.height - componentPos.height) / 2;
                left = hostPos.left - componentPos.width - margin;
                break;
            case EquisPositionsType.RIGHT:
                top = hostPos.top + (hostPos.height - componentPos.height) / 2;
                left = hostPos.right + margin;
                break;
            default:
                top = hostPos.top - componentPos.height - margin;
                left = hostPos.left + (hostPos.width - componentPos.width) / 2;
                break;
        }
        top = top + scrollPosY;
        left = left + scrollPosX;
        return { top, left };
    }
}
EquisTooltipPositionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisTooltipPositionService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
EquisTooltipPositionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisTooltipPositionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisTooltipPositionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

let delay = 1500;
class EquisTooltipDirective {
    constructor(componentInsertionService, tooltipPositionService, el, appRef, navigatorService) {
        this.componentInsertionService = componentInsertionService;
        this.tooltipPositionService = tooltipPositionService;
        this.el = el;
        this.appRef = appRef;
        this.navigatorService = navigatorService;
        this.tooltipContent = '';
    }
    set tooltipDirection(pos) {
        switch (pos) {
            case EquisPositionsType.RIGHT:
                this.position = EquisPositionsType.RIGHT;
                break;
            case EquisPositionsType.BOTTOM:
                this.position = EquisPositionsType.BOTTOM;
                break;
            case EquisPositionsType.LEFT:
                this.position = EquisPositionsType.LEFT;
                break;
            default:
                this.position = EquisPositionsType.TOP;
                break;
        }
    }
    set tooltipMobileCloseDelay(ms) {
        delay = ms;
    }
    onMouseEnter() {
        if (!this.tooltipInstance) {
            this.show();
        }
    }
    onMouseLeave() {
        if (this.tooltipInstance) {
            this.hide();
        }
    }
    onFocus() {
        if (!this.tooltipInstance) {
            this.show();
        }
    }
    onBlur() {
        if (this.tooltipInstance) {
            this.hide();
        }
    }
    onTouchStart() {
        if (!this.tooltipInstance) {
            this.show();
        }
    }
    onTouchEnd() {
        if (this.tooltipInstance) {
            this.hide();
        }
    }
    ngOnInit() {
        if (this.navigatorService.isBrowser) {
            this.resize$ = fromEvent(window, 'resize').subscribe(() => {
                if (this.tooltipInstance) {
                    this.allocate();
                }
            });
            this.scroll$ = fromEvent(window, 'scroll').subscribe(() => {
                if (this.tooltipInstance) {
                    this.allocate();
                }
            });
        }
    }
    show() {
        if (this.navigatorService.isBrowser) {
            this.tooltipId = this.componentInsertionService.create(EquisTooltipComponent, document.body);
            this.tooltipInstance =
                this.componentInsertionService.getComponentInstance(this.tooltipId);
            this.componentInsertionService.setProperty(this.tooltipId, 'content', this.tooltipContent);
            this.componentInsertionService.setProperty(this.tooltipId, 'fixedWidth', this.tooltipFixedWidth);
            this.componentInsertionService.setProperty(this.tooltipId, 'theme', this.tooltipTheme);
            this.appRef.tick();
            this.allocate();
        }
    }
    allocate() {
        if (this.navigatorService.isBrowser && this.tooltipInstance) {
            const tooltipPosition = this.tooltipPositionService.getPosition(this.el.nativeElement, this.tooltipInstance, this.position, 8);
            this.componentInsertionService.setProperty(this.tooltipId, 'direction', tooltipPosition.redirection);
            const index = this.tooltipPositionService.getIndex(this.tooltipzIndex);
            if (index) {
                this.componentInsertionService.setStyle(this.tooltipId, index.style, index.value);
            }
            if (tooltipPosition.afterLeft) {
                const afterLeft = tooltipPosition.afterLeft +
                    parseFloat(this.tooltipInstance.instance.afterLeft?.replace('%', ''));
                this.componentInsertionService.setProperty(this.tooltipId, 'afterLeft', `${afterLeft}%`);
            }
            else if (tooltipPosition.afterTop) {
                const afterTop = tooltipPosition.afterTop +
                    parseFloat(this.tooltipInstance.instance.afterTop.replace('%', ''));
                this.componentInsertionService.setProperty(this.tooltipId, 'afterTop', `${afterTop}%`);
            }
            this.appRef.tick();
            const elementPosition = {
                top: tooltipPosition.top,
                left: tooltipPosition.left,
                position: 'absolute',
            };
            this.componentInsertionService.setPosition(this.tooltipId, elementPosition);
        }
    }
    hide() {
        if (this.navigatorService.isBrowser && this.tooltipInstance) {
            this.componentInsertionService.destroy(this.tooltipId);
        }
        this.tooltipInstance = null;
        this.tooltipId = null;
    }
    ngOnDestroy() {
        if (this.resize$) {
            this.resize$.unsubscribe();
        }
        if (this.scroll$) {
            this.scroll$.unsubscribe();
        }
        this.hide();
    }
}
EquisTooltipDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisTooltipDirective, deps: [{ token: i1$1.EquisComponentInsertionService }, { token: EquisTooltipPositionService }, { token: i0.ElementRef }, { token: i0.ApplicationRef }, { token: i1$1.EquisNavigatorService }], target: i0.ɵɵFactoryTarget.Directive });
EquisTooltipDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.3.0", type: EquisTooltipDirective, selector: "[zTooltip], [equisTooltip]", inputs: { tooltipDirection: "tooltipDirection", tooltipMobileCloseDelay: "tooltipMobileCloseDelay", tooltipContent: "tooltipContent", tooltipFixedWidth: "tooltipFixedWidth", tooltipTheme: "tooltipTheme", tooltipzIndex: "tooltipzIndex" }, host: { listeners: { "mouseenter": "onMouseEnter()", "mouseleave": "onMouseLeave()", "focus": "onFocus()", "blur": "onBlur()", "touchstart": "onTouchStart()", "touchend": "onTouchEnd()" } }, exportAs: ["zTooltip", "equisTooltip"], ngImport: i0 });
__decorate([
    debounceDecorator(delay)
], EquisTooltipDirective.prototype, "onTouchEnd", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisTooltipDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[zTooltip], [equisTooltip]',
                    exportAs: 'zTooltip, equisTooltip',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.EquisComponentInsertionService }, { type: EquisTooltipPositionService }, { type: i0.ElementRef }, { type: i0.ApplicationRef }, { type: i1$1.EquisNavigatorService }]; }, propDecorators: { tooltipDirection: [{
                type: Input
            }], tooltipMobileCloseDelay: [{
                type: Input
            }], tooltipContent: [{
                type: Input
            }], tooltipFixedWidth: [{
                type: Input
            }], tooltipTheme: [{
                type: Input
            }], tooltipzIndex: [{
                type: Input
            }], onMouseEnter: [{
                type: HostListener,
                args: ['mouseenter']
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }], onFocus: [{
                type: HostListener,
                args: ['focus']
            }], onBlur: [{
                type: HostListener,
                args: ['blur']
            }], onTouchStart: [{
                type: HostListener,
                args: ['touchstart']
            }], onTouchEnd: [{
                type: HostListener,
                args: ['touchend']
            }] } });

class EquisTooltipModule {
    static forRoot() {
        return {
            ngModule: EquisTooltipModule,
        };
    }
}
EquisTooltipModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisTooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisTooltipModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisTooltipModule, declarations: [EquisTooltipComponent, EquisTooltipDirective], imports: [CommonModule], exports: [EquisTooltipComponent, EquisTooltipDirective] });
EquisTooltipModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisTooltipModule, providers: [
        EquisComponentInsertionService,
        EquisNavigatorService,
        EquisWindowService,
    ], imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisTooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisTooltipComponent, EquisTooltipDirective],
                    imports: [CommonModule],
                    exports: [EquisTooltipComponent, EquisTooltipDirective],
                    providers: [
                        EquisComponentInsertionService,
                        EquisNavigatorService,
                        EquisWindowService,
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
                }]
        }] });

var EquisTooltipPositions;
(function (EquisTooltipPositions) {
    EquisTooltipPositions["BOTTOM"] = "bottom";
    EquisTooltipPositions["TOP"] = "top";
    EquisTooltipPositions["RIGHT"] = "right";
    EquisTooltipPositions["LEFT"] = "left";
    EquisTooltipPositions["BOTTOM_RIGHT"] = "bottom-right";
    EquisTooltipPositions["BOTTOM_LEFT"] = "bottom-left";
    EquisTooltipPositions["TOP_RIGHT"] = "top-right";
    EquisTooltipPositions["TOP_LEFT"] = "top-left";
    EquisTooltipPositions["LEFT_TOP"] = "left-top";
    EquisTooltipPositions["LEFT_BOTTOM"] = "left-bottom";
    EquisTooltipPositions["RIGHT_TOP"] = "right-top";
    EquisTooltipPositions["RIGHT_BOTTOM"] = "right-bottom";
    EquisTooltipPositions["TOP_LEFT_ICON"] = "top-left-icon";
})(EquisTooltipPositions || (EquisTooltipPositions = {}));

/*
 * Public API Surface of z-tooltip
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EquisTooltipComponent, EquisTooltipDirective, EquisTooltipModule, EquisTooltipPositionService, EquisTooltipPositions };
